import { render, staticRenderFns } from "./MailQueues.vue?vue&type=template&id=3a1f60f5&"
import script from "./MailQueues.vue?vue&type=script&lang=js&"
export * from "./MailQueues.vue?vue&type=script&lang=js&"
import style0 from "./MailQueues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports